<template>
  <div :class="['center-switch', {'border-bottom': hasbottomline}]">
      <div class="swiitch-content">
          <span>{{label}}</span>
            <v-switch
              v-model="switch2"
              @change="(e) => switch2Change(e)"
              inset
              dense
            ></v-switch>
            <span class="tip" v-if="!!tipLabel">{{tipLabel}}</span>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    tipLabel: String,
    inValue: Boolean,
    isContol: Boolean,
    hasbottomline: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      switch2: false,
    };
  },
  watch: {
    inValue(val) {
      this.switch2 = val;
    }
  },
  methods: {
    switch2Change(e) {
      if (!this.isContol) {
      this.switch2 = !e;
      }
      this.$emit('change', e)
    }
  }
};
</script>
<style lang="scss" scoped>

    .border-bottom {
      border-bottom: 1px solid #D7DBEC;
    }
    .center-switch {
          padding: 0px 28px 0 0;
          margin-top: 11px;
          width: 100%;
      .swiitch-content {
          display: flex;
          align-items: center;
          span {
            white-space: nowrap;
            font-family: PingFangSC-Semibold;
            font-size: 14px;
            color: #5A607F;
            margin-right: 26px;
          }
        }
        .tip {
          font-family: PingFangSC-Semibold;
          font-size: 12px;
          color: #A1A7C4;
        }
    }
</style>
